import { useNavigate } from "react-router-dom";

import { useTranslateContext } from "../../contexts/translate.context";
import { usePartnerContext } from "../../contexts/partner.context";
import { useAlertMessageContext } from "../../contexts/alert-message.context";

import DashboardHeader from "../headers/dashboard.header";
import { Card, Container, Image } from "react-bootstrap";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import styles from './FinancialDashboard.module.scss';

import Jet from '../../assets/images/Jetski.svg';
import Lancha from '../../assets/images/Lancha.svg';
import Navegando from '../../assets/images/Navegando.svg';
import Abastecimento from '../../assets/images/Abastecimento.svg';
import Manutencao_externa from '../../assets/images/Manutencao_externa.svg';
import Movimento_entrada from '../../assets/images/Movimento_entrada.svg';
import Movimento_saida from '../../assets/images/Movimento_saida.svg';
import Higiene from '../../assets/images/Limpeza.svg';
import Warehouse from '../../assets/images/Warehouse.svg';
import Users from '../../assets/images/Users.svg';
import CashCoin from '../../assets/images/CashCoin.svg';
import CartCheck from '../../assets/images/CartCheck.svg';
import Wallet2 from '../../assets/images/Wallet2.svg';
import BarChartIcon from '../../assets/images/BarChart.svg';
import ClockHistory from '../../assets/images/ClockHistory.svg';
import SportsScore from '../../assets/images/SportsScore.svg';
import Tools from '../../assets/images/Tools.svg';
import Selo from '../../assets/images/selo.png';

import { Box } from "@mui/material";
import { ClockAndClimate } from "./components/ClockAndClimate";
import { ResumeBox, ResumeBoxCard } from "./components/ResumeBox";
import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import Loader from "../../components/loader/loader";
import { TFilter } from "../../types/FilterType";
import { floatMask, removeFormatDate } from "../../utilities/masks";
import lclService from "../../services/lcl.service";
import { arrivalForecast, browsingDelay, dateToString, floatToString, monthName, notNullToDate, toDate, toFloat, toInt, toLowerCase, toStringFloat } from "../../utilities/auxiliary-functions";
import { isEmpty } from "../../utilities/validators";
import { AlertMessageEnum, getVessel } from "../../utilities/types";
import { VESSEL_JETSKI, VESSEL_LANCHA } from "../../utilities/constants";
import { CardDataGrid } from "./components/CardDataGrid";
import { useMediaContext } from "../../contexts/media.context";
import moment from "moment";
import { StripCard, StripBox } from "./components/StripBox";

import { Bar, BarChart, ResponsiveContainer, CartesianGrid, Cell, LabelList, Legend, Pie, PieChart, Tooltip, XAxis, YAxis } from 'recharts';
import authService from "../../services/auth.service";

interface IFinancialDashboardProps {
}

export const FinancialDashboard: React.FC<IFinancialDashboardProps> = () => {

    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const alertContext = useAlertMessageContext();
    const navigator = useNavigate();

	const title: string = "Gestão Financeira";
	const description: string = "";

    let reloadPage: boolean = false;
    const [ loading, setLoading ] = useState(false);
    
    const [ countLancha, setCountLancha ]  = useState(0);
    const [ countJetski, setCountJetski ]  = useState(0);

    const [ sumPaid, setSumPaid ] = useState(0);
    const [ sumWaiting, setSumWaiting ] = useState(0);
    const [ sumDelay, setSumDelay ] = useState(0);
    const [ sumParcel, setSumParcel ] = useState(0);

    const [ selectedYear, setSelectedYear ] = useState('2025');

    const [ paymentPerForm, setPaymentPerForm ] = useState({} as any);
    const [ paymentPerAccompany, setPaymentPerAccompany ] = useState({} as any);

    /* constantes de objetos */
    const DropdownProps = {
        PaperProps: {
            style: {
                width: 160,
                maxHeight: 500
            }
        }
    } 

    const yearOptions = [
        {
            label: '2025',
            value: '2025'
        },{
            label: '2024',
            value: '2024'
        },{
            label: '2023',
            value: '2023'
        }
    ]

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
    const RADIAN = Math.PI / 180;
    
    const renderFormLabel = (props: any) => {

        const {
            cx,
            cy,
            midAngle,
            outerRadius,
            fill,
            payload,
            value,
        } = props;
        
        const sin = Math.sin(-RADIAN * midAngle);
        const cos = Math.cos(-RADIAN * midAngle);
        const sx = cx + (outerRadius + 10) * cos;
        const sy = cy + (outerRadius + 10) * sin;
        const mx = cx + (outerRadius + 30) * cos;
        const my = cy + (outerRadius + 30) * sin;
        const ex = mx + (cos >= 0 ? 1 : -1) * 30;
        const ey = my;
        const textAnchor = cos >= 0 ? "start" : "end";
        
        return (
            <g>
                <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
                <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
                <text style={{ fontWeight: "bold" }} x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill={fill} >
                    {display.label[toLowerCase(payload.name)]}
                </text>
                <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999" >
                    {toStringFloat(value)}
                </text>
            </g>
        );
    };

    const CustomTooltip = (props: any) => {

        const { active, payload } = props;

        if (active && payload && payload.length) {
            return (
                <div className="financial-accompany-tooltip">
                    <span style={{color : payload[0].color }}>{`${payload[0].name} : ${toStringFloat(payload[0].value)}`}</span>
                    <span style={{color : payload[1].color }}>{`${payload[1].name} : ${toStringFloat(payload[1].value)}`}</span>
                </div>
            );
        }
        return null;
    };

    async function searchFilter() {
        let currentDateStart = moment([selectedYear, 0, 1]);
        let currentDateEnd = moment([selectedYear, 11, 31]);

        let dateStart = removeFormatDate(currentDateStart.format('DD/MM/YYYY hh:mm:ss'));
        let dateEnd = removeFormatDate(currentDateEnd.format('DD/MM/YYYY hh:mm:ss'));

        if (!isEmpty(partner)) {
            try {
                const resultMonthlyPaymentPerVessels = await lclService.monthlyPaymentPerVessel(partner.id, dateStart, dateEnd);
                const vessels = resultMonthlyPaymentPerVessels;

                let countJetski = 0;
                let countLancha = 0;
                vessels.forEach((vessel: any) => {
                    if (toInt(vessel.typeVessel) === VESSEL_JETSKI)
                        countJetski = vessel.qtyVessel;
                    else
                        countLancha = vessel.qtyVessel;
                });
                setCountJetski(countJetski);
                setCountLancha(countLancha);

                const resultMonthlyPayments = await lclService.monthlyPayment(partner.id, dateStart, dateEnd);
                let localSumPaid = 0;
                let localSumWaiting = 0;
                let localSumParcel = 0;
                let localSumDelay = 0;

                for ( var mp = 0; mp < resultMonthlyPayments.length; mp++ ) {
                    const resultMonthlyPayment = resultMonthlyPayments[mp];
                    
                    localSumPaid += toFloat(resultMonthlyPayment.sumPaid);
                    localSumWaiting += toFloat(resultMonthlyPayment.sumWaiting);
                    localSumParcel += toFloat(resultMonthlyPayment.sumParcel);
                    localSumDelay += toFloat(resultMonthlyPayment.sumDelay);
                }
                setSumPaid(localSumPaid);
                setSumWaiting(localSumWaiting);
                setSumParcel(localSumParcel);
                setSumDelay(localSumDelay);
            
                const resultMonthlyPaymentPerForms = await lclService.monthlyPaymentPerForm(partner.id, dateStart, dateEnd);
                const localPaymentPerForm = [] as any;
                for ( let mf = 0; mf < resultMonthlyPaymentPerForms.length; mf++ ) {
                    const localPayment = localPaymentPerForm.find((localPayment: any) => localPayment.name === resultMonthlyPaymentPerForms[mf].paymentForm);
                    if (localPayment) {
                        localPayment.value += toFloat(resultMonthlyPaymentPerForms[mf].sumParcel);
                        for (let lp = 0; lp < localPaymentPerForm.length; lp++) {
                            if (localPaymentPerForm[lp].name === localPayment.name) {
                                localPaymentPerForm[lp] = localPayment;
                                break;
                            }
                        }
                    } else {
                        localPaymentPerForm[localPaymentPerForm.length] = {
                            name: resultMonthlyPaymentPerForms[mf].paymentForm,
                            value: toFloat(resultMonthlyPaymentPerForms[mf].sumParcel)
                        }
                    }
                }
                setPaymentPerForm(localPaymentPerForm);

                const resultMonthlyPaymentPerAccompanies = await lclService.monthlyPaymentPerAccompany(partner.id, dateStart, dateEnd);
                const localPaymentPerAccompany = [] as any;
                for ( let ma = 0; ma < resultMonthlyPaymentPerAccompanies.length; ma++ ) {
                    localPaymentPerAccompany[localPaymentPerAccompany.length] = {
                        name: monthName((resultMonthlyPaymentPerAccompanies[ma].monthy).toString()),
                        provided: toFloat(resultMonthlyPaymentPerAccompanies[ma].sumProvided),
                        realized: toFloat(resultMonthlyPaymentPerAccompanies[ma].sumRealized)
                    }
                }
                setPaymentPerAccompany(localPaymentPerAccompany);
            } catch(error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, title, error);
            }
        }
    }

    useEffect(() => {
        if (isEmpty(partner))
            // eslint-disable-next-line react-hooks/exhaustive-deps
            partner = authService.currentPartner();

        if (!reloadPage) {
            reloadPage = true;

            setLoading(true)
            setTimeout(() => {
               // searchFilter().finally(() => {
                setLoading(false);
              // });
            }, 500);
        }
    }, []);

    useEffect(() => {
        searchFilter();
    }, [selectedYear]);
    
    function viewDashboard() {
        return (
            <Container fluid className="page-body dashboards">
                <Box className="dashboards-search">
                    <InputLabel id="selected-year">Ano</InputLabel>
                    <FormControl variant="standard" sx={{ minWidth: 160, maxWidth: 160, fontSize: 26, marginRight: 2 }}>
                        <Select
                            sx={{fontSize: 30}}
                            labelId="selected-year"
                            id="selected-year-select"
                            value={selectedYear}
                            onChange={e =>
                                setSelectedYear(e.target.value)
                            }
                            label="Ano"
                            MenuProps={DropdownProps}
                        >
                            {yearOptions?.map(
                            (
                                option: any,
                                index: {
                                    toString: () => React.Key | null | undefined
                                }
                            ) => (
                                <MenuItem
                                    selected={selectedYear === option.value }
                                    key={index.toString()}
                                    value={option.value}
                                >
                                    {option.label}
                                </MenuItem>
                            )
                            )}
                        </Select>
                    </FormControl>
                </Box>
                <StripBox>
                    <StripCard className="blue" label="Embarcações" datas={[{ image: Lancha, value: String(countLancha || 0) }, { image: Jet, value: String(countJetski || 0) }]} />
                    <StripCard className="cyan" label="Total Previsto" image={CashCoin} value={`R$ ${floatToString(sumParcel)}`} />
                    <StripCard className="green" label="Recebido" image={CartCheck} value={`R$ ${floatToString(sumPaid)}`} />
                    <StripCard className="reddish_pink" label="Em Atraso" image={Wallet2} value={`R$ ${floatToString(sumDelay)}`} />
                    <StripCard className="orange" label="A Vencer" image={BarChartIcon} value={`R$ ${floatToString(sumWaiting)}`} />
                </StripBox>
                <Box className="d-flex justify-content-between gap-2">
                    <Card className='flex-grow-1'>
                        <Card.Header>
                            <Card.Title>Previsto X Realizado</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <ResponsiveContainer width="100%" height={400}>
                                <BarChart data={paymentPerAccompany} height={90}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" tick={{ fill: '#FFFFFF' }} />
                                    <YAxis tick={{ fill: '#FFFFFF' }}/>
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend />
                                    <Bar barSize={100} dataKey="provided" name={display.label.provided} fill="#00C49F"> 
                                    </Bar>
                                    <Bar barSize={100} dataKey="realized" name={display.label.realized} fill="#FF8042">
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>
                            <Card.Title>Tipo de Pagamento</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <PieChart width={500} height={400}>
                                <Pie
                                    data={paymentPerForm}
                                    //cx={120}
                                    //cy={200}
                                    innerRadius={50}
                                    outerRadius={80}
                                    fill="#8884d8"
                                    paddingAngle={5}
                                    dataKey="value"
                                    label={ renderFormLabel }
                                >
                                    {Object.keys(paymentPerForm).length > 0 && paymentPerForm.map((form: any, index: number) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}> 
                                            {`R$ ${form}`}
                                        </Cell>
                                    ))}
                                </Pie>
                            </PieChart>
                        </Card.Body>
                    </Card>
                </Box>
            </Container>
        );
    }
    
    return (
        <div className="dashboard">
            <DashboardHeader title={title} description={description} />
            {loading ? <Loader /> : viewDashboard()}
        </div>
    );
}

export default FinancialDashboard;
